import React from "react";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";

export const PROVIDER_ADD_NEW = "__add_new__";
export const PROVIDER_NONE = "__none__";

// Reusable Transportation Provider picker: a dropdown of known providers with a
// "+ Add new provider…" escape hatch that reveals a text input for a brand-new name.
export function ProviderField({ label, value, options, onChange, testid }) {
  const val = (value || "").trim();
  const [adding, setAdding] = React.useState(false);
  const showInput = adding;
  return (
    <div className="space-y-2">
      <Label>{label}</Label>
      {showInput ? (
        <div className="flex gap-2">
          <Input
            autoFocus
            value={value || ""}
            onChange={(e) => onChange(e.target.value)}
            placeholder="Type new provider name"
            data-testid={`${testid}-new-input`}
          />
          <button
            type="button"
            className="text-xs text-muted-foreground underline whitespace-nowrap"
            onClick={() => { setAdding(false); onChange(""); }}
            data-testid={`${testid}-cancel-new`}
          >
            Pick from list
          </button>
        </div>
      ) : (
        <Select
          value={val || PROVIDER_NONE}
          onValueChange={(v) => {
            if (v === PROVIDER_ADD_NEW) { setAdding(true); onChange(""); }
            else if (v === PROVIDER_NONE) { onChange(""); }
            else { onChange(v); }
          }}
        >
          <SelectTrigger data-testid={testid}>
            <SelectValue placeholder="Select a provider" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value={PROVIDER_NONE}>— None —</SelectItem>
            {options.map((p) => (
              <SelectItem key={p} value={p} data-testid={`${testid}-opt-${p}`}>{p}</SelectItem>
            ))}
            <SelectItem value={PROVIDER_ADD_NEW} data-testid={`${testid}-add-new`}>+ Add new provider…</SelectItem>
          </SelectContent>
        </Select>
      )}
    </div>
  );
}

// Build the provider dropdown option list: known providers plus whatever is already
// saved on the student (so an existing value is never dropped from the list).
export function useProviderOptions(transportProviders, ...currentValues) {
  return React.useMemo(() => {
    const set = new Set((transportProviders || []).filter(Boolean));
    currentValues.forEach((v) => { if (v && v.trim()) set.add(v.trim()); });
    return Array.from(set).sort((a, b) => a.localeCompare(b));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transportProviders, ...currentValues]);
}
